import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingOverlay from 'react-loading-overlay';
import { withRouter, Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { verifyToken, cleanRedirectState } from '../../../../state/services/authService';
import { getAllFPs, deleteFpDetail } from '../../../../state/services/fpService';
import Select from 'react-select';
import axios from 'axios';
import { API_HOST, HTTP_PROTOCOL } from '../../../../config';
import { toast } from 'react-toastify';

class FreightProviders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allFPs: [],
            fpFuelLevyList: [],
            fpCarries: [],
            fpFilter: {
                value: 'All',
                label: 'All Freight Providers',
            },
            username: null,
            loading: false,
        };
    }

    static propTypes = {
        verifyToken: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        redirect: PropTypes.bool.isRequired,
        getAllFPs: PropTypes.func.isRequired,
        cleanRedirectState: PropTypes.func.isRequired,
        deleteFpDetail: PropTypes.func.isRequired,
        urlAdminHome: PropTypes.string.isRequired,
        allFPs: PropTypes.array.isRequired,
    }

    notify = (text) => toast(text);

    componentDidMount() {
        this.setState({ loading: true });
        const token = localStorage.getItem('token');

        if (token && token.length > 0) {
            this.props.verifyToken();
        } else {
            localStorage.setItem('isLoggedIn', 'false');
            this.props.cleanRedirectState();
            this.props.history.push('/admin');
        }

        this.props.getAllFPs();
        this.setState({ loading: false });
    }

    componentDidUpdate(prevProps, prevState) {
        const { allFPs } = prevProps;
        if (prevState.fpFilter !== this.state.fpFilter) {
            if (allFPs) {
                if (this.state.fpFilter.value === 'All') {
                    this.setState({ allFPs });
                } else {
                    this.setState({
                        allFPs: allFPs.filter(fp => fp.fp_markupfuel_levy_percent > 0),
                    });
                }
            }
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const { redirect, allFPs, needUpdateFpDetails } = newProps;
        const currentRoute = this.props.location.pathname;
        if (redirect && currentRoute != '/') {
            localStorage.setItem('isLoggedIn', 'false');
            this.props.cleanRedirectState();
            this.props.history.push('/');
        }
        if (allFPs) {
            this.setState({ allFPs });
            this.setState({ fpFuelLevyList: allFPs.map(fp => {
                return { id: fp.id, value: fp.fp_markupfuel_levy_percent };
            })});
        }
        if (needUpdateFpDetails) {
            this.props.getAllFPs();
        }
    }

    removeFpDetail(event, fp) {
        this.setState({ loading: true });
        confirmAlert({
            title: 'Confirm to delete Freight Provider',
            message: 'Are you sure to do this?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => { this.props.deleteFpDetail(fp); this.props.getAllFPs(); }
                },
                {
                    label: 'No',
                    onClick: () => console.log('Click No')
                }
            ]
        });

        this.setState({ loading: false });
        event.preventDefault();
    }

    onInputChange(event, fp) {
        const fpFuelLevyList = this.state.fpFuelLevyList;
        const index = fpFuelLevyList.findIndex(item => item.id === fp.id);
        fpFuelLevyList[index].value = parseFloat(event.target.value);
        this.setState({ fpFuelLevyList });
        event.preventDefault();
    }

    onSetFuelLevyPercent() {
        this.setState({ loading: true });
        const token = localStorage.getItem('token');
        const options = {
            method: 'post',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
            url: `${HTTP_PROTOCOL}://${API_HOST}/fp/set_fuel_levy_percent/`,
            data: this.state.fpFuelLevyList
        };
        axios(options)
            .then(() => {
                this.notify('Successfully Done!');
                this.setState({ loading: false });
            })
            .catch((error) => {
                this.notify('Failed: ' + error);
                this.setState({ loading: false });
            });
    }

    render() {
        const { allFPs, fpFilter, fpFuelLevyList } = this.state;

        const fpsList = allFPs.map((fp, index) => {
            const fpFuelLevy = fpFuelLevyList.filter(item=> item.id === fp.id)[0];
            return (
                <tr key={index}>
                    <td>{fp.id}</td>
                    <td>{fp.fp_company_name}</td>
                    <td>{fp.fp_address_country}</td>
                    <td className="input-field-wrapper">
                        <input type="number" className="form-control" placeholder="Fuel Levy Percent" value={fpFuelLevy.value} onChange={(e) => this.onInputChange(e, fpFuelLevy)} />
                    </td>
                    <td><Link className="btn btn-info btn-sm" to={'/admin/providers/edit/' + fp.id}>Edit</Link>&nbsp;&nbsp;<a onClick={(event) => this.removeFpDetail(event, fp)} className="btn btn-danger btn-sm" href="javascript:void(0)">Delete</a></td>
                </tr>
            );
        });

        return (
            <div>
                <div className="pageheader">
                    <h1>Freight Providers</h1>
                    <div className="breadcrumb-wrapper hidden-xs">
                        <span className="label">You are here:</span>
                        <ol className="breadcrumb">
                            <li><a href={this.props.urlAdminHome}>Home</a>
                            </li>
                            <li className="active">Freight Providers</li>
                        </ol>
                    </div>
                </div>
                <section id="main-content" className="animated fadeInUp">
                    <LoadingOverlay
                        active={this.state.loading}
                        spinner
                        text='Loading...'
                    >
                        <div className="row">
                            <div className="col-md-12">
                                <div className="panel panel-default">
                                    <div className="panel-heading">
                                        <h3 className="panel-title">Freight Providers</h3>
                                        <div className="actions pull-right d-flex">
                                            <Select
                                                className="select"
                                                value={fpFilter}
                                                onChange={(e) => this.setState({fpFilter: e})}
                                                options={[
                                                    {value: 'All', label: 'All Freight Providers'},
                                                    {value: 'Active', label: 'Active Freight Providers'},
                                                ]}
                                                placeholder='Select a option'
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        height: 42,
                                                        minHeight: 42,
                                                        width: 250,
                                                    })
                                                }}

                                            />
                                            <button className="btn btn-info" onClick={() => this.onSetFuelLevyPercent()}>
                                                Set Fuel Levy Percent
                                            </button>
                                            <Link className="btn btn-success" to="/admin/providers/add">Add New</Link>
                                        </div>
                                    </div>
                                    <div className="panel-body">
                                        <table id="example" className="table table-striped table-bordered" cellSpacing="0" width="100%">
                                            <thead>
                                                <tr>
                                                    <th>id</th>
                                                    <th>Name</th>
                                                    <th>Country</th>
                                                    <th>Fuel Levy Percent</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {fpsList}
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </LoadingOverlay>
                    
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        redirect: state.auth.redirect,
        allFPs: state.fp.allFPs,
        username: state.auth.username,
        needUpdateFpDetails: state.fp.needUpdateFpDetails,
        urlAdminHome: state.url.urlAdminHome,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        verifyToken: () => dispatch(verifyToken()),
        cleanRedirectState: () => dispatch(cleanRedirectState()),
        getAllFPs: () => dispatch(getAllFPs()),
        deleteFpDetail: (fp) => dispatch(deleteFpDetail(fp)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FreightProviders));



// WEBPACK FOOTER //
// ./src/pages/admin/AdminViews/FreightProviders/FreightProviders.js